import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Box, Button, CircularProgress, Container, Paper, SxProps, Theme } from '@mui/material';
import insightLogo from 'assets/i2p_logo.png';
import { Redirect, useHistory } from 'react-router-dom';
import { useTitle } from 'react-use';
import ZeptoLogo from 'shared/components/ZeptoLogo';
import { routes } from 'shared/constants';

const rootStyles: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const loginCardStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  width: '70%',
  maxWidth: '400px',
  height: '70%',
  maxHeight: '600px',
  paddingLeft: '25px',
  paddingRight: '25px',
};
const loginActionContainerStyles: SxProps<Theme> = {
  height: '40%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
};
const buttonStyles: SxProps<Theme> = {
  width: '50%',
  maxWidth: '300px',
};
const insightLogoStyles: SxProps<Theme> = {
  height: '50px',
  width: 'auto',
  alignSelf: 'flex-end',
  marginBottom: '-100px',
  marginTop: '-20px',
};

export const Login = () => {
  useTitle(`Sign In`);
  const history = useHistory();
  const { instance, inProgress } = useMsal();

  const startLogin = async () => {
    await instance.loginRedirect();
    history.push(routes.listQuotes);
  };

  if (
    inProgress !== InteractionStatus.None &&
    inProgress !== InteractionStatus.Startup &&
    (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect)
  )
    return (
      <Container sx={rootStyles}>
        <CircularProgress color='secondary' />
      </Container>
    );

  return (
    <>
      <AuthenticatedTemplate>
        <Redirect to={routes.listQuotes} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Box sx={rootStyles}>
          <Paper elevation={3} sx={loginCardStyles}>
            <Box component='img' alt='logo' src={insightLogo} sx={insightLogoStyles} />
            <ZeptoLogo />
            <Box sx={loginActionContainerStyles}>
              <Button color='primary' variant='contained' sx={buttonStyles} onClick={startLogin}>
                Log In
              </Button>
            </Box>
          </Paper>
        </Box>
      </UnauthenticatedTemplate>
    </>
  );
};
